import { Controller } from "@hotwired/stimulus"

// Submit on Enter (Shift+Enter for a newline), auto-grow the textarea, and mark
// the conversation read when the composer is focused.
export default class extends Controller {
  static targets = ["input"]
  static values = { readUrl: String }

  submit(event) {
    if (event.shiftKey) return

    event.preventDefault()
    this.element.requestSubmit()
  }

  resize() {
    const input = this.inputTarget
    input.style.height = "auto"
    input.style.height = `${input.scrollHeight}px`
  }

  read() {
    fetch(this.readUrlValue, {
      method: "PATCH",
      headers: {
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content
      }
    })
  }
}
